/**
 * Helper function to satisfy TypeScript undefined checks when regular code doesn't succeed in it
 */

export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
